import * as Mod1 from "./discourse/components/composer-presence-display";
import * as Mod2 from "./discourse/components/topic-presence-display";
import * as Mod3 from "./discourse/connectors/before-composer-controls/presence.gjs";
import * as Mod4 from "./discourse/connectors/topic-above-footer-buttons/presence.gjs";
import * as Mod5 from "./discourse/initializers/presence-admin-plugin-configuration-nav";
import * as Mod6 from "./discourse/services/composer-presence-manager";
const compatModules = {
  "discourse/components/composer-presence-display": Mod1,
  "discourse/components/topic-presence-display": Mod2,
  "discourse/connectors/before-composer-controls/presence": Mod3,
  "discourse/connectors/topic-above-footer-buttons/presence": Mod4,
  "discourse/initializers/presence-admin-plugin-configuration-nav": Mod5,
  "discourse/services/composer-presence-manager": Mod6,
};
export default compatModules;
